import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const AssignOrgEmail = ({ selectedProducts, userObj, onClick }) => {
  const navigate = useNavigate();
  const { sharedObject, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      sharedObject: state.sharedObject,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    })
  );
  useEffect(() => {
    setAnswers(selectedProducts);
    setSuccessFlag(false);
  }, [selectedProducts]);
  const [answers, setAnswers] = useState();
  const [processing, setProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false); //
  const [errCreateMsg, setErrCreateMsg] = useState(false);
  const setAnswer = async (email, chkd, type) => {
    const temp = [];
    for (const eml of answers) {
      if (eml.directEmailAddress === email) {
        if (type === "email") {
          eml.assignEmail = chkd;
        } else {
          eml.notify = chkd;
        }
      }
      temp.push(eml);
    }
    setAnswers(temp);
  };
  const SubmitForm = async () => {
    setErrCreateMsg(false);
    setSuccessFlag(false);
    const ID = [];
    for (const user of userObj) {
      ID.push(user.id);
    }
    const temp = [];
    const obj = [];
    let orgId = answers[0].organizationId;
    //let id = [userObj[0].id];
    for (const eml of answers) {
      let flag = !eml.sharingAllowed && eml.emailList.length === 1;
      if (eml.assignEmail && !flag) {
        temp.push(eml.directEmailId);
        obj.push(eml);
      }
    }
    if (temp.length === 0) {
      setErrCreateMsg(true);
      return;
    }
    setProcessing(true);
    let call = `/users/AssignEmail?directEmailIds=${encodeURIComponent(
      temp
    )}&users=${encodeURIComponent(ID)}`;
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject({ ...sharedObject.getUserEmails, obj });
      setProcessing(false);
      setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  return (
    <div className="AssignOrgEmail">
      <div
        className="modal fade"
        id="SharedOrgEmailModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="SharedOrgEmail"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title " id="myModalLabel">
                Assign Organization Email
              </div>
              <button type="button" className="close" onClick={onClick}>
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            {successFlag ? (
              <>
                <div className="bi-success-check">
                  <i
                    className="bi bi-check2-circle"
                    alt="Success Checkmark"
                  ></i>
                </div>
                <div className="message-wrapper">
                  The organization email has been assigned successfully.
                </div>
              </>
            ) : (
              <div className="modal-body">
                <div className="descript2-container">
                  The following list of organization emails can be selected for
                  users to send and receive all emails from the same mailbox.
                </div>
                {selectedProducts.map((el) => {
                  return (
                    <div
                      className="spacer-margin8 spacer-margin9"
                      key={el.directEmailId}
                    >
                      <input
                        type="checkbox"
                        name={"emailCheck" + el.directEmailId}
                        // value={answers["emailCheck" + el.id]}
                        className="form-control"
                        onClick={(elem) =>
                          setAnswer(
                            el.directEmailAddress,
                            elem.target.checked,
                            "email"
                          )
                        }
                      />
                      <span className="blk-clr spacer-margin2">
                        {el.directEmailAddress}
                      </span>
                    </div>
                  );
                })}
                {errCreateMsg ? (
                  <div
                    className={`alert alert-danger sp-margin4`}
                    dangerouslySetInnerHTML={{
                      __html: "At least one email must be selected.",
                    }}
                  />
                ) : null}
                {processing ? <div className="loading"></div> : null}
              </div>
            )}
            <div className="modal-footer">
              {successFlag ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  data-target="#SuccessOrgEmailModal"
                  onClick={() => SubmitForm()}
                >
                  Assign
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClick}
              >
                {successFlag ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignOrgEmail;
